<template>
  <form
    :class="isMassiveSearch ? 'albums-search search-large' : 'albums-search'"
    @submit.prevent=""
    >
    <div class="form-row isrc-option">
      <h5>Change by {{ !searchType ? 'ISRC' : 'UPC' }}</h5>
      <AppToggle @update-toggle="updateSearchType($event)"/>
    </div>

    <div class="form-row">
      <input
        type="text"
        class="form-input"
        v-model="value"
        :placeholder="`Enter ${ typeValue }`"
        @keyup.enter.prevent="inputEnterEvent()"
      >

      <button
        v-if="isMassiveSearch"
        type="button"
        class="form-button"
        :disabled="value.length < 5"
        @click="addItem(value)"
      >Add</button>

      <button
        type="button"
        class="form-button"
        :disabled="isMassiveSearch ? valuesArray.length === 0 : value.length < 5"
        @click="search()"
      >Submit</button>
    </div>

    <div
      v-if="isMassiveSearch && valuesArray.length > 0"
      class="massive-data"
    >
      <h4>Items to search</h4>

      <div class="massive-items">
        <SearchItem
          v-for="(item, index) in valuesArray"
          :key="index"
          :item="item"
          @delete-item="deleteItem(index)"
        />
      </div>
    </div>
  </form>
</template>

<script>
import AppToggle from '@/components/AppToggle'
import SearchItem from '@/components/SearchItem'
import { useAlbumStore } from '@/stores/album'

export default {
  name: "AlbumSearch",

  components: { AppToggle, SearchItem },

  setup() {
    const store = useAlbumStore()

    return { store }
  },

  props: {
    isMassiveSearch: {
      type: Boolean, // false -> Individual, true -> Massive
      default: false
    }
  },

  data() {
    return {
      value: '',
      valuesArray: [],
      searchType: false,
      typeValue: 'UPC'
    }
  },

  methods: {
    search() {
      if (this.isMassiveSearch) {
        this.$emit('searchMassive', { value: this.valuesArray, type: this.searchType })
      } else {
        this.$emit('searchIndividual', { value: this.value, type: this.searchType })
      }
    },

    inputEnterEvent() {
      if (this.value.length < 5) return

      (this.isMassiveSearch) ? this.addItem(this.value) : this.search()
    },

    updateSearchType(type) {
      this.searchType = type;
      this.typeValue = type ? 'ISRC' : 'UPC'
      this.$emit('changeType', this.typeValue)
    },

    addItem(item) {
      if (this.value.indexOf(' ') !== -1) {
        const itemsToAdd = item.split(' ')
        this.valuesArray = [...new Set(this.valuesArray.concat(itemsToAdd))] // Create a new array with distinct values
        this.value = ''
        return
      }

      if (this.valuesArray.indexOf(item) === -1) {
        this.valuesArray.push(item)
        this.value = ''
      } else {
        this.$notify({
          text: 'Item repeated! Try again',
          type: 'warn',
          duration: 2000,
          ignoreDuplicates: true
        })
      }
    },

    deleteItem(index) {
      const id = this.valuesArray[index]

      if (this.store.massiveItems) {
        this.store.addToDeletedItems(id)
      }

      this.valuesArray.splice(index, 1)
    }
  }
}
</script>

<style lang="scss">
.albums-search {
  display: flex;
  flex-direction: column;
  width: 500px;
  padding: 20px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
  margin: 0 auto;
}

.form-row {
  display: flex;
  justify-content: space-between;
  width: 100%;

  .form-input {
    padding: 4px 10px;
    font-size: 1em;
    width: 300px;
    text-align: center;
    color: #626262;
    font-family: Avenir, Helvetica, Arial, sans-serif;
  }

  &.isrc-option {
    margin-bottom: 20px;
  }

  .form-button {
    &:last-child {
      background-color: #42b983;
    }
  }
}

.search-large {
  width: 900px;

  .form-row {
    padding: 0 calc(40px / 6);
    justify-content: center;

    * {
      margin: 0 5px;
    }
  }
}

.massive-data {
  margin: 20px 0 0;
  display: flex;
  flex-direction: column;

  .massive-items {
    display: flex;
    flex-wrap: wrap;
    padding: 10px 0;
  }
}
</style>
